<template>
    <div class="fui-i fui-field fui-label-floating fui-select-field">
        <div class="fui-input-container relative">
            <span v-if="$slots.default" class="fui-icon">
                <slot></slot>
            </span>

            <label :class="[labelClass]" :for="id">{{ label }}&nbsp;<span v-if="required" class="fui-required">*</span></label>

            <select
                :id="id"
                v-model="model"
                :name="name"
                :required="required"
                :class="[inputClass]"
            >
                <option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</option>
            </select>
        </div>
    </div>
</template>

<script setup>
import { computed, shallowRef } from 'vue';

const {
    name, label, options, required, labelClass, inputClass,
} = defineProps({
    name: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        required: true,
    },
    options: {
        type: Array,
        required: true,
    },
    required: {
        type: Boolean,
        default: false,
    },
    labelClass: {
        type: [String, Array, Object],
        default: 'fui-label absolute top-2 left-4 text-xs text-primary-500',
    },
    inputClass: {
        type: [String, Array, Object],
        default: 'fui-select pt-6 pb-2',
    },
});

const id = computed(() => {
    return name.replaceAll('[', '-').replaceAll(']', '');
});

const model = defineModel({
    type: String,
    default: '',
});
</script>
